import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { TranslateService } from './translate.service';

/** Type of the handleError function returned by HttpErrorHandler.createHandleError */
export type HandleError =
  <T> (operation?: string, result?: T) => (error: HttpErrorResponse) => Observable<T>;

/** Handles HttpClient errors */
@Injectable()
export class HttpErrorHandler {
  constructor(private router: Router,
    private translate: TranslateService,
    private messageService: MessageService,
    private spinner: NgxSpinnerService) { }

  /** Create curried handleError function that already knows the service name */
  createHandleError = (serviceName = '') => {
    return <T>(operation = 'operation', result = {} as T) =>
      this.handleError(serviceName, operation, result);
  }

  /**
   * Returns a function that handles Http operation failures.
   * This error handler lets the app continue to run as if no error occurred.
   * @param serviceName = name of the data service that attempted the operation
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  handleError<T>(serviceName = '', operation = 'operation', result = {} as T) {
    return (error: HttpErrorResponse): Observable<T> => {
      this.spinner.hide();
      // TODO: send the error to remote logging infrastructure
      console.error("error  ", error.status); // log to console instead
      console.error(error.error); // log to console instead

      if (!!error.status && error.status === 509) {
        this.router.navigate(['/maintenance']);
        return of();
      }

      const err = (!!error && !!error.error) ? error.error : {};

      // const message = (error.error instanceof ErrorEvent) ?
      const message = (!!err.message_code) ? this.translate.fnTransform(err.message_code) : `server returned code ${error.status} with body "${error.error}"`;

      if (!!error.status && error.status === 401 && !!err.message_code && err.message_code == 'unauthenticated') {
        this.router.navigate(['/login']);
        return of();
      }

      if (!!err.message_code && ['mobile_in_use'].indexOf(err.message_code) > -1) {

      } else {
        // TODO: better job of transforming error for user consumption
        // this.messageService.add({severity:'error', summary:'Error Message', detail:`${operation} failed: ${message}`});
        
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: `${message}` });
        return of();
      }

      // Let the app keep running by returning a safe result.
      return of(err);
    };

  }
}
